// extracted by mini-css-extract-plugin
export var errorBanner = "_lk-2";
export var scroller = "_lk-0";
export var thinking = "_lk-1";
export var visuallyHidden = "_lk-3";